import { render, staticRenderFns } from "./OffsiteLocationForm.vue?vue&type=template&id=b4b7947c"
import script from "./OffsiteLocationForm.vue?vue&type=script&lang=js"
export * from "./OffsiteLocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports